export interface IHistoryState {
  historyHasBack: boolean;
  reloadingCurrentPage: boolean;
}

export const getHistoryState = (): IHistoryState => {
  const historyHasBack = history.state?.back ?? false;
  const reloadingCurrentPage =
    history.state?.current === window.location.pathname;

  return {
    historyHasBack,
    reloadingCurrentPage,
  };
};
